var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedXava0)",
    d: "M13.478 5.644a1.641 1.641 0 0 0-2.957 0l-4.753 9.348c-.591 1.17.214 2.58 1.479 2.58c.3 0 .587-.095.827-.27l2.923-2.148a1.71 1.71 0 0 1 2.07.026l2.644 2.036a1.7 1.7 0 0 0 1.041.356c1.265 0 2.07-1.41 1.479-2.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedXava1)",
    d: "M7.765 11.07c.429.214 1.097.639 1.942 1.354c1.555 1.316 3.762.66 4.401-.064c.617-.703.986-1.093 2.074-1.393l-2.704-5.323a1.641 1.641 0 0 0-2.957 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedXava2)",
    d: "M8.575 9.472c.279.184.622.445.977.788c.607.592 1.416.93 2.263.943c.446 0 1.496-.214 2.477-1.127a6.6 6.6 0 0 1 1.02-.823l-1.834-3.609a1.641 1.641 0 0 0-2.957 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4746",
    d: "m9.32 8.002l1.2-2.358a1.642 1.642 0 0 1 2.958 0l1.059 2.088a3.33 3.33 0 0 1-2.713 1.362A3.36 3.36 0 0 1 9.32 8.002"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedXava0",
    x1: 12.132,
    x2: 11.987,
    y1: 12.596,
    y2: 17.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedXava1",
    x1: 11.999,
    x2: 11.999,
    y1: 4.714,
    y2: 17.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FF6C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4746"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedXava2",
    x1: 11.999,
    x2: 11.999,
    y1: 4.713,
    y2: 17.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF8368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FF4746"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXava);
export default __webpack_public_path__ + "static/media/xava.d2e7706d034e2c1d1fe7d215540f7eee.svg";
export { ForwardRef as ReactComponent };